import React from "react";
import clsx from "clsx";
import * as buttonClass from "../../styles/communs/button.module.scss";

const Button = React.forwardRef(({
    children, style, className, onClick, role, id, onKeyDown, onKeyUp, ...props
}, ref) => {
    const attr = {}

    if (props['aria-selected']) {
        attr['aria-selected'] = props['aria-selected']
    }

    if (props['aria-controls']) {
        attr['aria-controls'] = props['aria-controls']
    }

    return (<button
        ref={ref}
        className={clsx({[buttonClass.button]: className == null, [className]: className !== null})}
        style={style}
        onClick={onClick}
        role={role}
        {...attr}
        id={id}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
    >
        {children}
    </button>);
});

Button.defaultProps = {
    children: {}, style: {}, className: null, role: undefined, id: undefined, onClick: () => {
    }, onKeyDown: () => {
    }, onKeyUp: () => {
    }, 'aria-selected': "", 'aria-controls': "",
}

export default Button;
